import dayjs, { Dayjs } from "dayjs";
import nl from "dayjs/locale/nl";
import calendar from "dayjs/plugin/calendar";
import duration from "dayjs/plugin/duration";
import localizedFormat from "dayjs/plugin/localizedFormat";
import relativeTime from "dayjs/plugin/relativeTime";
import updateLocale from "dayjs/plugin/updateLocale";
import utcPlugin from "dayjs/plugin/utc";

dayjs.locale(nl);

dayjs.extend(calendar);
dayjs.extend(duration);
dayjs.extend(localizedFormat);
dayjs.extend(relativeTime);
dayjs.extend(updateLocale);
dayjs.extend(utcPlugin);

dayjs.updateLocale("nl", {
	calendar: {
		lastDay: "[Gisteren om] LT",
		sameDay: "[Vandaag om] LT",
		nextDay: "[Morgen om] LT",
		lastWeek: "[Afgelopen] dddd [om] LT",
		nextWeek: "dddd [om] LT",
		sameElse: "L",
	},
});

const utcDayJs = dayjs.utc;
function utcToLocal(dateTime: Dayjs): Dayjs {
	return dayjs.utc(dateTime).local();
}

/**
 * Formats a number of seconds as total `H:mm` (hours never wrap at 24h). Use this for durations —
 * `dayjs.duration(x).format('HH:mm')` renders only the hours-within-a-day component and silently drops
 * whole days, so anything ≥ 24h displays wrong.
 */
function formatSecondsAsDuration(seconds: number | string): string {
	const total = Math.max(0, Math.floor(Number(seconds) || 0));
	const hours = Math.floor(total / 3600);
	const minutes = Math.floor((total % 3600) / 60);

	return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`;
}

export { dayjs as date, utcDayJs as utcDate, utcToLocal, formatSecondsAsDuration };
export default dayjs;
